// frontend/admin-portal/src/providers/AppProviders.jsx
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { PermissionsProvider } from "@fiberhome/shared-ui";
import { AuthProvider, useAuth } from "../contexts/AuthContext";
import { SettingsProvider } from "../contexts/SettingsContext";

function AuthBoundProviders({ children }) {
  const { permissions } = useAuth();
  return (
    <PermissionsProvider permissions={permissions}>
      <SettingsProvider>{children}</SettingsProvider>
    </PermissionsProvider>
  );
}

export default function AppProviders({ children }) {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AuthBoundProviders>{children}</AuthBoundProviders>
      </AuthProvider>
    </BrowserRouter>
  );
}
